import React from "react";
import IconButton from "../../utils/IconButton";
import MusicPlayer from "./MusicPlayer";
import { Snackbar } from "@mui/material";

const MusicPlayerSnackbar = ({isMusicMode, isFocusedMode, onMouseLeave }) => {

  return (
    <Snackbar
    open={isMusicMode}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    sx={{ marginBottom: "42px" }}
    
  >
  <IconButton
    onMouseLeave={onMouseLeave}
    sx={{
      display: isFocusedMode ? "none" : "inline-flex",
    }}
  >
    <MusicPlayer
      disabled={!isMusicMode}
      isZenMode={isFocusedMode}
    />
  </IconButton>

  </Snackbar>
  );
};

export default MusicPlayerSnackbar;